import { TRANSLATED_COUNTRIES } from "./Countries";

export const COUNTRIES_DATA = [
  {
    Pays: "Afghanistan",
    Devise: "Afghani",
    Code: "AFN",
  },
  {
    Pays: "Afrique du Sud",
    Devise: "Rand",
    Code: "ZAR",
  },
  {
    Pays: "Albanie",
    Devise: "Lek",
    Code: "ALL",
  },
  {
    Pays: "Algérie",
    Devise: "Dinar algérien",
    Code: "DZD",
  },
  {
    Pays: "Allemagne",
    Devise: "Euro",
    Code: "EUR",
  },
  {
    Pays: "Andorre",
    Devise: "Euro",
    Code: "EUR",
  },
  {
    Pays: "Angola",
    Devise: "Kwanza",
    Code: "AOA",
  },
  {
    Pays: "Antigua-et-Barbuda",
    Devise: "Dollar des Caraïbes orientales",
    Code: "XCD",
  },
  {
    Pays: "Arabie saoudite",
    Devise: "Riyal saoudien",
    Code: "SAR",
  },
  {
    Pays: "Argentine",
    Devise: "Peso argentin",
    Code: "ARS",
  },
  {
    Pays: "Arménie",
    Devise: "Dram arménien",
    Code: "AMD",
  },
  {
    Pays: "Australie",
    Devise: "Dollar australien",
    Code: "AUD",
  },
  {
    Pays: "Autriche",
    Devise: "Euro",
    Code: "EUR",
  },
  {
    Pays: "Azerbaïdjan",
    Devise: "Manat azerbaïdjanais",
    Code: "AZN",
  },
  {
    Pays: "Bahamas",
    Devise: "Dollar bahaméen",
    Code: "BSD",
  },
  {
    Pays: "Bahreïn",
    Devise: "Dinar bahreïnien",
    Code: "BHD",
  },
  {
    Pays: "Bangladesh",
    Devise: "Taka",
    Code: "BDT",
  },
  {
    Pays: "Barbade",
    Devise: "Dollar barbadien",
    Code: "BBD",
  },
  {
    Pays: "Belgique",
    Devise: "Euro",
    Code: "EUR",
  },
  {
    Pays: "Belize",
    Devise: "Dollar bélizéen",
    Code: "BZD",
  },
  {
    Pays: "Bénin",
    Devise: "Franc CFA (BCEAO)",
    Code: "XOF",
  },
  {
    Pays: "Bhoutan",
    Devise: "Ngultrum",
    Code: "BTN",
  },
  {
    Pays: "Biélorussie",
    Devise: "Rouble biélorusse",
    Code: "BYN",
  },
  {
    Pays: "Birmanie (Myanmar)",
    Devise: "Kyat",
    Code: "MMK",
  },
  {
    Pays: "Bolivie",
    Devise: "Boliviano",
    Code: "BOB",
  },
  {
    Pays: "Bosnie-Herzégovine",
    Devise: "Mark convertible",
    Code: "BAM",
  },
  {
    Pays: "Botswana",
    Devise: "Pula",
    Code: "BWP",
  },
  {
    Pays: "Brésil",
    Devise: "Réal",
    Code: "BRL",
  },
  {
    Pays: "Brunei",
    Devise: "Dollar de Brunei",
    Code: "BND",
  },
  {
    Pays: "Bulgarie",
    Devise: "Lev",
    Code: "BGN",
  },
  {
    Pays: "Burkina Faso",
    Devise: "Franc CFA (BCEAO)",
    Code: "XOF",
  },
  {
    Pays: "Burundi",
    Devise: "Franc burundais",
    Code: "BIF",
  },
  {
    Pays: "Cambodge",
    Devise: "Riel",
    Code: "KHR",
  },
  {
    Pays: "Cameroun",
    Devise: "Franc CFA (BEAC)",
    Code: "XAF",
  },
  {
    Pays: "Canada",
    Devise: "Dollar canadien",
    Code: "CAD",
  },
  {
    Pays: "Cap-Vert",
    Devise: "Escudo capverdien",
    Code: "CVE",
  },
  {
    Pays: "Chili",
    Devise: "Peso chilien",
    Code: "CLP",
  },
  {
    Pays: "Chine",
    Devise: "Yuan renminbi",
    Code: "CNY",
  },
  {
    Pays: "Chypre",
    Devise: "Euro",
    Code: "EUR",
  },
  {
    Pays: "Colombie",
    Devise: "Peso colombien",
    Code: "COP",
  },
  {
    Pays: "Comores",
    Devise: "Franc comorien",
    Code: "KMF",
  },
  {
    Pays: "Congo (République du)",
    Devise: "Franc CFA (BEAC)",
    Code: "XAF",
  },
  {
    Pays: "Congo (République démocratique du)",
    Devise: "Franc congolais",
    Code: "CDF",
  },
  {
    Pays: "Corée du Nord",
    Devise: "Won nord-coréen",
    Code: "KPW",
  },
  {
    Pays: "Corée du Sud",
    Devise: "Won sud-coréen",
    Code: "KRW",
  },
  {
    Pays: "Costa Rica",
    Devise: "Colón costaricain",
    Code: "CRC",
  },
  {
    Pays: "Côte d'Ivoire",
    Devise: "Franc CFA (BCEAO)",
    Code: "XOF",
  },
  {
    Pays: "Croatie",
    Devise: "Euro",
    Code: "EUR",
  },
  {
    Pays: "Cuba",
    Devise: "Peso cubain",
    Code: "CUP",
  },
  {
    Pays: "Danemark",
    Devise: "Couronne danoise",
    Code: "DKK",
  },
  {
    Pays: "Djibouti",
    Devise: "Franc djiboutien",
    Code: "DJF",
  },
  {
    Pays: "Dominique",
    Devise: "Dollar des Caraïbes orientales",
    Code: "XCD",
  },
  {
    Pays: "Égypte",
    Devise: "Livre égyptienne",
    Code: "EGP",
  },
  {
    Pays: "Émirats arabes unis",
    Devise: "Dirham des Émirats",
    Code: "AED",
  },
  {
    Pays: "Équateur",
    Devise: "Dollar américain",
    Code: "USD",
  },
  {
    Pays: "Érythrée",
    Devise: "Nakfa",
    Code: "ERN",
  },
  {
    Pays: "Espagne",
    Devise: "Euro",
    Code: "EUR",
  },
  {
    Pays: "Estonie",
    Devise: "Euro",
    Code: "EUR",
  },
  {
    Pays: "Eswatini",
    Devise: "Lilangeni",
    Code: "SZL",
  },
  {
    Pays: "États-Unis",
    Devise: "Dollar américain",
    Code: "USD",
  },
  {
    Pays: "Éthiopie",
    Devise: "Birr éthiopien",
    Code: "ETB",
  },
  {
    Pays: "Fidji",
    Devise: "Dollar fidjien",
    Code: "FJD",
  },
  {
    Pays: "Finlande",
    Devise: "Euro",
    Code: "EUR",
  },
  {
    Pays: "France",
    Devise: "Euro",
    Code: "EUR",
  },
  {
    Pays: "Gabon",
    Devise: "Franc CFA (BEAC)",
    Code: "XAF",
  },
  {
    Pays: "Gambie",
    Devise: "Dalasi",
    Code: "GMD",
  },
  {
    Pays: "Géorgie",
    Devise: "Lari géorgien",
    Code: "GEL",
  },
  {
    Pays: "Ghana",
    Devise: "Cedi ghanéen",
    Code: "GHS",
  },
  {
    Pays: "Grèce",
    Devise: "Euro",
    Code: "EUR",
  },
  {
    Pays: "Grenade",
    Devise: "Dollar des Caraïbes orientales",
    Code: "XCD",
  },
  {
    Pays: "Guatemala",
    Devise: "Quetzal guatémaltèque",
    Code: "GTQ",
  },
  {
    Pays: "Guinée",
    Devise: "Franc guinéen",
    Code: "GNF",
  },
  {
    Pays: "Guinée-Bissau",
    Devise: "Franc CFA (BCEAO)",
    Code: "XOF",
  },
  {
    Pays: "Guinée équatoriale",
    Devise: "Franc CFA (BEAC)",
    Code: "XAF",
  },
  {
    Pays: "Guyana",
    Devise: "Dollar guyanais",
    Code: "GYD",
  },
  {
    Pays: "Haïti",
    Devise: "Gourde",
    Code: "HTG",
  },
  {
    Pays: "Honduras",
    Devise: "Lempira hondurien",
    Code: "HNL",
  },
  {
    Pays: "Hongrie",
    Devise: "Forint hongrois",
    Code: "HUF",
  },
  {
    Pays: "Îles Marshall",
    Devise: "Dollar américain",
    Code: "USD",
  },
  {
    Pays: "Inde",
    Devise: "Roupie indienne",
    Code: "INR",
  },
  {
    Pays: "Indonésie",
    Devise: "Roupie indonésienne",
    Code: "IDR",
  },
  {
    Pays: "Irak",
    Devise: "Dinar irakien",
    Code: "IQD",
  },
  {
    Pays: "Iran",
    Devise: "Rial iranien",
    Code: "IRR",
  },
  {
    Pays: "Irlande",
    Devise: "Euro",
    Code: "EUR",
  },
  {
    Pays: "Islande",
    Devise: "Couronne islandaise",
    Code: "ISK",
  },
  {
    Pays: "Israël",
    Devise: "Nouveau shekel",
    Code: "ILS",
  },
  {
    Pays: "Italie",
    Devise: "Euro",
    Code: "EUR",
  },
  {
    Pays: "Jamaïque",
    Devise: "Dollar jamaïcain",
    Code: "JMD",
  },
  {
    Pays: "Japon",
    Devise: "Yen japonais",
    Code: "JPY",
  },
  {
    Pays: "Jordanie",
    Devise: "Dinar jordanien",
    Code: "JOD",
  },
  {
    Pays: "Kazakhstan",
    Devise: "Tenge kazakh",
    Code: "KZT",
  },
  {
    Pays: "Kenya",
    Devise: "Shilling kényan",
    Code: "KES",
  },
  {
    Pays: "Kirghizistan",
    Devise: "Som kirghize",
    Code: "KGS",
  },
  {
    Pays: "Kiribati",
    Devise: "Dollar australien",
    Code: "AUD",
  },
  {
    Pays: "Koweït",
    Devise: "Dinar koweïtien",
    Code: "KWD",
  },
  {
    Pays: "Laos",
    Devise: "Kip lao",
    Code: "LAK",
  },
  {
    Pays: "Lesotho",
    Devise: "Loti",
    Code: "LSL",
  },
  {
    Pays: "Lettonie",
    Devise: "Euro",
    Code: "EUR",
  },
  {
    Pays: "Liban",
    Devise: "Livre libanaise",
    Code: "LBP",
  },
  {
    Pays: "Liberia",
    Devise: "Dollar libérien",
    Code: "LRD",
  },
  {
    Pays: "Libye",
    Devise: "Dinar libyen",
    Code: "LYD",
  },
  {
    Pays: "Liechtenstein",
    Devise: "Franc suisse",
    Code: "CHF",
  },
  {
    Pays: "Lituanie",
    Devise: "Euro",
    Code: "EUR",
  },
  {
    Pays: "Luxembourg",
    Devise: "Euro",
    Code: "EUR",
  },
  {
    Pays: "Macédoine du Nord",
    Devise: "Denar",
    Code: "MKD",
  },
  {
    Pays: "Madagascar",
    Devise: "Ariary",
    Code: "MGA",
  },
  {
    Pays: "Malaisie",
    Devise: "Ringgit",
    Code: "MYR",
  },
  {
    Pays: "Malawi",
    Devise: "Kwacha",
    Code: "MWK",
  },
  {
    Pays: "Maldives",
    Devise: "Rufiyaa",
    Code: "MVR",
  },
  {
    Pays: "Mali",
    Devise: "Franc CFA (BCEAO)",
    Code: "XOF",
  },
  {
    Pays: "Malte",
    Devise: "Euro",
    Code: "EUR",
  },
  {
    Pays: "Maroc",
    Devise: "Dirham marocain",
    Code: "MAD",
  },
  {
    Pays: "Maurice",
    Devise: "Roupie mauricienne",
    Code: "MUR",
  },
  {
    Pays: "Mauritanie",
    Devise: "Ouguiya",
    Code: "MRU",
  },
  {
    Pays: "Mexique",
    Devise: "Peso mexicain",
    Code: "MXN",
  },
  {
    Pays: "Micronésie",
    Devise: "Dollar américain",
    Code: "USD",
  },
  {
    Pays: "Moldavie",
    Devise: "Leu moldave",
    Code: "MDL",
  },
  {
    Pays: "Monaco",
    Devise: "Euro",
    Code: "EUR",
  },
  {
    Pays: "Mongolie",
    Devise: "Tugrik",
    Code: "MNT",
  },
  {
    Pays: "Monténégro",
    Devise: "Euro",
    Code: "EUR",
  },
  {
    Pays: "Mozambique",
    Devise: "Metical",
    Code: "MZN",
  },
  {
    Pays: "Namibie",
    Devise: "Dollar namibien",
    Code: "NAD",
  },
  {
    Pays: "Nauru",
    Devise: "Dollar australien",
    Code: "AUD",
  },
  {
    Pays: "Népal",
    Devise: "Roupie népalaise",
    Code: "NPR",
  },
  {
    Pays: "Nicaragua",
    Devise: "Córdoba nicaraguayen",
    Code: "NIO",
  },
  {
    Pays: "Niger",
    Devise: "Franc CFA (BCEAO)",
    Code: "XOF",
  },
  {
    Pays: "Nigeria",
    Devise: "Naira",
    Code: "NGN",
  },
  {
    Pays: "Norvège",
    Devise: "Couronne norvégienne",
    Code: "NOK",
  },
  {
    Pays: "Nouvelle-Zélande",
    Devise: "Dollar néo-zélandais",
    Code: "NZD",
  },
  {
    Pays: "Oman",
    Devise: "Rial omanais",
    Code: "OMR",
  },
  {
    Pays: "Ouganda",
    Devise: "Shilling ougandais",
    Code: "UGX",
  },
  {
    Pays: "Ouzbékistan",
    Devise: "Soum",
    Code: "UZS",
  },
  {
    Pays: "Pakistan",
    Devise: "Roupie pakistanaise",
    Code: "PKR",
  },
  {
    Pays: "Palaos",
    Devise: "Dollar américain",
    Code: "USD",
  },
  {
    Pays: "Panama",
    Devise: "Balboa",
    Code: "PAB",
  },
  {
    Pays: "Papouasie-Nouvelle-Guinée",
    Devise: "Kina",
    Code: "PGK",
  },
  {
    Pays: "Paraguay",
    Devise: "Guarani",
    Code: "PYG",
  },
  {
    Pays: "Pays-Bas",
    Devise: "Euro",
    Code: "EUR",
  },
  {
    Pays: "Pérou",
    Devise: "Sol péruvien",
    Code: "PEN",
  },
  {
    Pays: "Philippines",
    Devise: "Peso philippin",
    Code: "PHP",
  },
  {
    Pays: "Pologne",
    Devise: "Zloty",
    Code: "PLN",
  },
  {
    Pays: "Portugal",
    Devise: "Euro",
    Code: "EUR",
  },
  {
    Pays: "Qatar",
    Devise: "Riyal qatari",
    Code: "QAR",
  },
  {
    Pays: "République centrafricaine",
    Devise: "Franc CFA (BEAC)",
    Code: "XAF",
  },
  {
    Pays: "République dominicaine",
    Devise: "Peso dominicain",
    Code: "DOP",
  },
  {
    Pays: "Roumanie",
    Devise: "Leu roumain",
    Code: "RON",
  },
  {
    Pays: "Royaume-Uni",
    Devise: "Livre sterling",
    Code: "GBP",
  },
  {
    Pays: "Russie",
    Devise: "Rouble",
    Code: "RUB",
  },
  {
    Pays: "Rwanda",
    Devise: "Franc rwandais",
    Code: "RWF",
  },
  {
    Pays: "Saint-Kitts-et-Nevis",
    Devise: "Dollar des Caraïbes orientales",
    Code: "XCD",
  },
  {
    Pays: "Saint-Vincent-et-les-Grenadines",
    Devise: "Dollar des Caraïbes orientales",
    Code: "XCD",
  },
  {
    Pays: "Sainte-Lucie",
    Devise: "Dollar des Caraïbes orientales",
    Code: "XCD",
  },
  {
    Pays: "Saint-Marin",
    Devise: "Euro",
    Code: "EUR",
  },
  {
    Pays: "Salomon (Îles)",
    Devise: "Dollar des Îles Salomon",
    Code: "SBD",
  },
  {
    Pays: "Salvador",
    Devise: "Dollar américain",
    Code: "USD",
  },
  {
    Pays: "Samoa",
    Devise: "Tala samoan",
    Code: "WST",
  },
  {
    Pays: "Sao Tomé-et-Principe",
    Devise: "Dobra",
    Code: "STN",
  },
  {
    Pays: "Sénégal",
    Devise: "Franc CFA (BCEAO)",
    Code: "XOF",
  },
  {
    Pays: "Serbie",
    Devise: "Dinar serbe",
    Code: "RSD",
  },
  {
    Pays: "Seychelles",
    Devise: "Roupie seychelloise",
    Code: "SCR",
  },
  {
    Pays: "Sierra Leone",
    Devise: "Leone",
    Code: "SLL",
  },
  {
    Pays: "Singapour",
    Devise: "Dollar de Singapour",
    Code: "SGD",
  },
  {
    Pays: "Slovaquie",
    Devise: "Euro",
    Code: "EUR",
  },
  {
    Pays: "Slovénie",
    Devise: "Euro",
    Code: "EUR",
  },
  {
    Pays: "Somalie",
    Devise: "Shilling somalien",
    Code: "SOS",
  },
  {
    Pays: "Soudan",
    Devise: "Livre soudanaise",
    Code: "SDG",
  },
  {
    Pays: "Soudan du Sud",
    Devise: "Livre sud-soudanaise",
    Code: "SSP",
  },
  {
    Pays: "Sri Lanka",
    Devise: "Roupie sri-lankaise",
    Code: "LKR",
  },
  {
    Pays: "Suède",
    Devise: "Couronne suédoise",
    Code: "SEK",
  },
  {
    Pays: "Suisse",
    Devise: "Franc suisse",
    Code: "CHF",
  },
  {
    Pays: "Suriname",
    Devise: "Dollar surinamais",
    Code: "SRD",
  },
  {
    Pays: "Syrie",
    Devise: "Livre syrienne",
    Code: "SYP",
  },
  {
    Pays: "Tadjikistan",
    Devise: "Somoni",
    Code: "TJS",
  },
  {
    Pays: "Tanzanie",
    Devise: "Shilling tanzanien",
    Code: "TZS",
  },
  {
    Pays: "Tchad",
    Devise: "Franc CFA (BEAC)",
    Code: "XAF",
  },
  {
    Pays: "Tchéquie (République tchèque)",
    Devise: "Couronne tchèque",
    Code: "CZK",
  },
  {
    Pays: "Thaïlande",
    Devise: "Baht",
    Code: "THB",
  },
  {
    Pays: "Timor oriental",
    Devise: "Dollar américain",
    Code: "USD",
  },
  {
    Pays: "Togo",
    Devise: "Franc CFA (BCEAO)",
    Code: "XOF",
  },
  {
    Pays: "Tonga",
    Devise: "Paʻanga",
    Code: "TOP",
  },
  {
    Pays: "Trinité-et-Tobago",
    Devise: "Dollar trinidadien",
    Code: "TTD",
  },
  {
    Pays: "Tunisie",
    Devise: "Dinar tunisien",
    Code: "TND",
  },
  {
    Pays: "Turkménistan",
    Devise: "Manat turkmène",
    Code: "TMT",
  },
  {
    Pays: "Turquie",
    Devise: "Livre turque",
    Code: "TRY",
  },
  {
    Pays: "Tuvalu",
    Devise: "Dollar australien",
    Code: "AUD",
  },
  {
    Pays: "Ukraine",
    Devise: "Hryvnia",
    Code: "UAH",
  },
  {
    Pays: "Uruguay",
    Devise: "Peso uruguayen",
    Code: "UYU",
  },
  {
    Pays: "Vanuatu",
    Devise: "Vatu",
    Code: "VUV",
  },
  {
    Pays: "Vatican",
    Devise: "Euro",
    Code: "EUR",
  },
  {
    Pays: "Venezuela",
    Devise: "Bolívar",
    Code: "VES",
  },
  {
    Pays: "Viêt Nam",
    Devise: "Dong vietnamien",
    Code: "VND",
  },
  {
    Pays: "Yémen",
    Devise: "Rial yéménite",
    Code: "YER",
  },
  {
    Pays: "Zambie",
    Devise: "Kwacha",
    Code: "ZMW",
  },
  {
    Pays: "Zimbabwe",
    Devise: "Dollar zimbabwéen",
    Code: "ZWL",
  },
];

export const COUNTRIES = COUNTRIES_DATA.map((country) => ({
  value: country.Pays,
  label: country.Pays,
}));

const CURRENCY_CODES = [
  ...new Set(COUNTRIES_DATA.map((country) => country.Code)),
];

export const CURRENCIES = [
  ...new Set(COUNTRIES_DATA.map((country) => country.Devise)),
].map((currency, index) => ({
  label: currency,
  value: CURRENCY_CODES[index],
}));

export const getTranslatedCountry = (
  country: string,
  language: "fr" | "en" | "es" | "it" | "de"
) => {
  return TRANSLATED_COUNTRIES[country as keyof typeof TRANSLATED_COUNTRIES][
    language
  ];
};
